/**
 * @generated SignedSource<<f9c530a3728ada60ff6bc02f51ae74a6>>
 * @relayHash 244ab9ad22ad5999f76de6292c7da1a5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 244ab9ad22ad5999f76de6292c7da1a5

import { ConcreteRequest } from 'relay-runtime';
export type historyEventsTableLookupsQuery$variables = {
  language: string;
};
export type historyEventsTableLookupsQuery$data = {
  readonly ch_officialLanguagesLookupTranslations: ReadonlyArray<{
    readonly isoLanguageName: string;
    readonly officialLanguageLookupId: number;
  }>;
  readonly ch_specializationTranslations: ReadonlyArray<{
    readonly name: string;
    readonly specializationId: number;
  }>;
  readonly ch_specialtyTranslations: ReadonlyArray<{
    readonly name: string;
    readonly specialtyId: number;
  }>;
  readonly displayableCountries: ReadonlyArray<{
    readonly countryIsoCode2: string;
    readonly countryName: string;
  }>;
};
export type historyEventsTableLookupsQuery = {
  response: historyEventsTableLookupsQuery$data;
  variables: historyEventsTableLookupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eq",
            "variableName": "language"
          }
        ],
        "kind": "ObjectValue",
        "name": "language"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specializationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialtyId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialLanguageLookupId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageName",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "historyEventsTableLookupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SpecializationTranslation",
        "kind": "LinkedField",
        "name": "ch_specializationTranslations",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SpecialtyTranslation",
        "kind": "LinkedField",
        "name": "ch_specialtyTranslations",
        "plural": true,
        "selections": [
          (v4/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OfficialLanguageLookupTranslation",
        "kind": "LinkedField",
        "name": "ch_officialLanguagesLookupTranslations",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v8/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "historyEventsTableLookupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SpecializationTranslation",
        "kind": "LinkedField",
        "name": "ch_specializationTranslations",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SpecialtyTranslation",
        "kind": "LinkedField",
        "name": "ch_specialtyTranslations",
        "plural": true,
        "selections": [
          (v4/*:: as any*/),
          (v3/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OfficialLanguageLookupTranslation",
        "kind": "LinkedField",
        "name": "ch_officialLanguagesLookupTranslations",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "244ab9ad22ad5999f76de6292c7da1a5",
    "metadata": {},
    "name": "historyEventsTableLookupsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fea204d7a962cd0f4d2d78b176ff8a66";

export default node;
